import Timeago from '@stimulus-components/timeago'
import { enUS, de } from 'date-fns/locale'

export default class extends Timeago {
  connect() {
    super.connect()
    // Never leave the element blank: if the relative-time enhancement produces no
    // text, fall back to the server-rendered absolute timestamp held in title.
    if (!this.element.textContent.trim()) {
      this.element.textContent = this.element.getAttribute('title') || ''
    }
  }

  disconnect() {
    super.disconnect()
  }

  get locale() {
    switch (document.documentElement.lang) {
      case 'de':
        return de
      default:
        return enUS
    }
  }
}
